import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Combine class names */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
